<h1 mat-dialog-title> Are you sure you want to proceed with this action?</h1>
<div mat-dialog-content>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="true">Yes</button>
  <button mat-button [mat-dialog-close]="false">No</button>
</div>

